import React, { useEffect, useState } from "react";
import FooterNew from "../components/Footer-New";
import Navbar from "../components/Navbar.js";

// import api
import { getCMSPage } from "../api/users.js";
import { getLang } from "../lib/localStorage.js";
import NavbarNew from "../components/Navbar-New.js";



export default function Regulatory(props) {
  const [content, setContent] = useState("");
  let langCode = getLang();

  // function
  const fetchCmsPage = async () => {
    try {
      const { status, result } = await getCMSPage({
        identifier: "privacy_policy",
        langCode,
      });
      // console.log("result", result);
      if (status == "success") {
        setContent(result);
        // console.log("content", content);
        document.title = "regulatory";
        const el = document.querySelector("meta[name='description']");
        el.setAttribute("content", result.metadescription);
        document.keywords = el;
        // console.log("el", el);
        const els = document.querySelector("meta[name='keywords']");
        els.setAttribute("content", result.metakeywords);
        document.description = els;
        // console.log("", els);
      }
    } catch (err) { }
  };

  useEffect(() => {
    fetchCmsPage();
  }, []);

  return (
    <div>
     
      <NavbarNew />
      <div className="innerpages_wrapper">
        <div className="container">
          <div className="dash_wrapper terms_content">
            <div className="row">

              <div className="col-xl-12">

                <h1>Regulatory & Governance Framework</h1>
                <h4 className="mt-5 mb-2">Our Operating Model</h4>
                <p>
                  MG Asset Management operates as an independent, privately
                  managed asset management business with a decentralized
                  operating structure designed to provide flexibility,
                  efficiency, and global reach.
                </p>
                <p>
                  We are not presented as a regulated bank, broker-dealer, or
                  deposit-taking institution, and we do not claim authorization
                  by any regulatory body unless expressly stated in specific
                  client documentation for a particular jurisdiction, entity, or
                  service arrangement.
                </p>
                <p>
                  Instead, our model is built around a robust internal governance
                  framework that applies many of the same standards expected
                  within leading financial institutions.
                </p>
                <h4 className="mt-5 mb-2">Commitment to High Standards</h4>
                <p>
                  Although our structure is independent and decentralized, we
                  maintain a strong commitment to operating in a manner
                  consistent with internationally recognized best practices in
                  financial services.
                </p>
                <p>
                  Our internal standards are guided by principles commonly
                  associated with major regulatory frameworks, including:
                </p>
                <ul className="list-disc list-inside pl-5">
                  <li>Transparency in client communications</li>
                  <li>Fair dealing and professional conduct</li>
                  <li>Risk management discipline</li>
                  <li>Anti-money laundering controls</li>
                  <li>Know Your Client (KYC) procedures</li>
                  <li>Data privacy and confidentiality</li>
                  <li>Internal oversight and recordkeeping</li>
                  <li>Conflicts of interest management</li>
                  <li>Operational resilience and security controls</li>
                </ul>
                <p>
                  Our objective is simple: to provide clients with confidence,
                  professionalism, and disciplined stewardship.
                </p>
                <h4 className="mt-5 mb-2">Why an Independent Structure Matters</h4>
                <p>
                  Our decentralized model allows us to remain agile,
                  client-focused, and free from many of the structural conflicts
                  often found within larger institutions.
                </p>
                <p>This enables us to prioritize:</p>
                <h4 className="mt-5 mb-2">Independent Decision-Making</h4>
                <p>
                  Investment and strategic decisions are made with a client-first
                  mindset rather than driven by large corporate product agendas.
                </p>
                <h4 className="mt-5 mb-2">Operational Efficiency</h4>
                <p>
                  A leaner structure allows us to move efficiently while
                  maintaining rigorous standards.
                </p>
                <h4 className="mt-5 mb-2">Global Perspective</h4>
                <p>
                  A decentralized framework supports broader market access,
                  flexible solutions, and modern cross-border capabilities where
                  legally permissible.
                </p>
                <h4 className="mt-5 mb-2">Long-Term Alignment</h4>
                <p>
                  We focus on sustainable client relationships and long-term
                  outcomes rather than short-term institutional pressures.
                </p>
                <h4 className="mt-5 mb-2">Governance & Internal Controls</h4>
                <p>
                  MG Asset Management maintains internal governance procedures
                  designed to support consistency, accountability, and prudent
                  management.
                </p>
                <p>These may include:</p>
                <ul className="list-disc list-inside pl-5">
                  <li>Periodic internal policy reviews</li>
                  <li>Client suitability and onboarding checks</li>
                  <li>Transaction monitoring procedures</li>
                  <li>Segregation of responsibilities where appropriate</li>
                  <li>Risk review processes</li>
                  <li>Secure data handling protocols</li>
                  <li>Counterparty due diligence standards</li>
                  <li>Documentation and audit trails</li>
                </ul>
                <p>
                  We believe robust internal controls are essential regardless of
                  formal licensing structure. Anti-Money Laundering (AML) & KYC
                  Standards. We take financial crime prevention seriously.
                </p>
                <p>Our onboarding and relationship processes may include:</p>
                <ul className="list-disc list-inside pl-5">
                  <li>Identity verification</li>
                  <li>Source of funds / source of wealth review</li>
                  <li>Sanctions and watchlist screening</li>
                  <li>Enhanced due diligence where required</li>
                  <li>Ongoing monitoring of client relationships</li>
                </ul>
                <p>
                  We reserve the right to decline or terminate any relationship
                  that does not meet our internal compliance standards.
                </p>
                <h4 className="mt-5 mb-2">
                  Client Suitability & Responsible Service Delivery
                </h4>
                <p>Not every investment strategy is appropriate for every client.</p>
                <p>We seek to ensure that services and opportunities are aligned with a client’s:</p>
                <ul className="list-disc list-inside pl-5">
                  <li>Objectives</li>
                  <li>Risk tolerance</li>
                  <li>Investment horizon</li>
                  <li>Liquidity requirements</li>
                  <li>Experience and sophistication level</li>
                </ul>
                <p>
                  This suitability-first approach reflects our commitment to
                  responsible asset management. Privacy, Confidentiality &
                  Security. Protecting client information is a core priority.
                </p>
                <p>We apply professional standards around:</p>
                <ul className="list-disc list-inside pl-5">
                  <li>Confidential handling of client data</li>
                  <li>Secure communications practices</li>
                  <li>Restricted access controls</li>
                  <li>Operational cybersecurity awareness</li>
                  <li>Responsible record retention</li>
                </ul>
                <p>
                  Discretion and privacy remain fundamental to our client
                  relationships.
                </p>
                <h4 className="mt-5 mb-2">Counterparty & Partner Standards</h4>
                <p>
                  Where external providers, custodians, banks, administrators, or
                  strategic partners are involved, we seek to work with
                  reputable counterparties and service providers that meet
                  appropriate commercial and operational standards.
                </p>
                <p>Due diligence may consider:</p>
                <ul className="list-disc list-inside pl-5">
                  <li>Reputation</li>
                  <li>Operational capability</li>
                  <li>Security standards</li>
                  <li>Jurisdictional standing</li>
                  <li>Service quality</li>
                  <li>Transparency to Clients</li>
                </ul>
                <p>
                  We believe clients should clearly understand who they are
                  working with and how services are delivered.
                </p>
                <p>Accordingly:</p>
                <ul className="list-disc list-inside pl-5">
                  <li>We do not misrepresent our status</li>
                  <li>We communicate our independent operating model openly</li>
                  <li>We explain risks and structures clearly</li>
                  <li>
                    We encourage clients to undertake independent due diligence
                  </li>
                </ul>
                <p>Trust is built through honesty and clarity.</p>
                <h4 className="mt-5 mb-2">Important Notice</h4>
                <p>
                  MG Asset Management’s internal governance standards should not
                  be interpreted as equivalent to government licensing,
                  statutory authorization, or formal regulatory supervision
                  unless specifically stated in written documentation for a
                  relevant entity or jurisdiction.
                </p>
                <p>
                  Certain services may be limited based on jurisdiction, client
                  eligibility, or legal considerations.
                </p>
                <h4 className="mt-5 mb-2">Our Philosophy</h4>
                <p>
                  Strong governance is not defined solely by a badge or license.
                  It is demonstrated through conduct, discipline, transparency,
                  and accountability.
                </p>
                <p>
                  MG Asset Management is committed to maintaining professional
                  standards that inspire confidence while delivering
                  independent, client-focused asset management solutions.
                </p>
                <h4 className="mt-5 mb-2">Contact Us</h4>
                <p>
                  For further information regarding our operating model,
                  governance standards, onboarding procedures, or jurisdictional
                  service availability, please contact our team directly.
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterNew />
    </div>
  );
}
